import React, { useState } from 'react';
import { SampleCsvSpec, downloadSampleCsv } from '../../../lib/exceptionSampleCsv';

interface BulkUploadBarProps {
  /** 샘플 CSV 정의 (헤더/예시행/파일명) */
  sample: SampleCsvSpec;
  /** 업로드 실행 — 성공/실패 알림은 상위에서 처리. throw 시 파일 유지 */
  onUpload: (file: File) => Promise<void>;
  label?: string;
  accept?: string;
}

/**
 * 예외처리 4개 탭 공통 인라인 업로드 바.
 * [라벨] [파일 선택] [업로드] .......... [샘플 CSV 다운로드]
 */
const BulkUploadBar: React.FC<BulkUploadBarProps> = ({
  sample,
  onUpload,
  label = 'Excel/CSV 일괄 업로드',
  accept = '.csv,.xlsx,.xls',
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [busy, setBusy] = useState(false);

  const handleUpload = async () => {
    if (!file) return;
    setBusy(true);
    try {
      await onUpload(file);
      setFile(null); // 성공 시에만 초기화
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12,
        padding: '10px 12px', background: '#f8f9fa', borderRadius: 8,
        border: '1px solid #e8eaed', flexWrap: 'wrap',
      }}
    >
      <span style={{ fontSize: 13, fontWeight: 600, color: '#5f6368', whiteSpace: 'nowrap' }}>{label}</span>
      <input
        key={file ? 'loaded' : 'empty'}
        type="file"
        accept={accept}
        onChange={(e) => setFile(e.target.files?.[0] ?? null)}
        style={{ fontSize: 13, flex: 1, minWidth: 180 }}
      />
      <button
        onClick={handleUpload}
        disabled={!file || busy}
        style={{
          padding: '5px 14px', background: file && !busy ? '#34a853' : '#ccc',
          color: '#fff', border: 'none', borderRadius: 6,
          cursor: file && !busy ? 'pointer' : 'not-allowed', fontSize: 13, whiteSpace: 'nowrap',
        }}
      >
        {busy ? '업로드 중...' : '업로드'}
      </button>
      <button
        type="button"
        onClick={() => downloadSampleCsv(sample)}
        style={{
          marginLeft: 'auto', background: 'none', border: 'none', color: '#1a73e8',
          cursor: 'pointer', fontSize: 13, textDecoration: 'underline', whiteSpace: 'nowrap',
        }}
      >
        샘플 CSV 다운로드
      </button>
    </div>
  );
};

export default BulkUploadBar;
